<div *ngIf="tripError">
    <div class="sticky-top mat-elevation-z6">
        <mat-toolbar class="trip-header-bar bds-toolbar-blue">
            <mat-toolbar-row>
                <span>
                    <fa-icon [icon]="icons.train" [fixedWidth]="true" size="lg"></fa-icon>
                    {{ tripError.carInit }} {{ tripError.carNo }}
                    <span class="small">{{
                        tripError.shipDateTime | date : 'MM/dd/yyyy HH:mm' : 'UTC'
                    }}</span>
                    <span *ngIf="isDirty">*</span>
                    <span *ngIf="isSaving">
                        <small>
                            (saving...)
                            <fa-icon [icon]="icons.spinner" [spin]="true"></fa-icon>
                        </small>
                    </span>
                    <a
                        mat-icon-button
                        title="Open Equipment in a new Tab"
                        [href]="equipmentAppPathProvider.EquipmentById(equipment.ormId) | async"
                        target="_blank"
                    >
                        <fa-icon [icon]="icons.popout"></fa-icon>
                    </a>
                </span>
                <span class="fill-remaining-space"></span>
                <span>
                    <button mat-stroked-button (click)="addImport()" [disabled]="isSaving || !canAddImport">
                        <fa-icon [icon]="icons.import"></fa-icon> Add Import
                    </button>
                    <button mat-stroked-button (click)="reProcess()" [disabled]="isSaving || !canReProcess">
                        <fa-icon [icon]="icons.reprocess"></fa-icon> Re Process
                    </button>
                    <button
                        mat-stroked-button
                        (click)="updateInterfaceValidation()"
                        [disabled]="isSaving || !canUpdateInterfaceValidation"
                    >
                        <fa-icon [icon]="icons.save"></fa-icon> Update Interface Validation
                    </button>
                    <rt-trip-error-more-options
                        [trip]="tripError"
                        [clms]="clms"
                        (resolve)="onResolveTripOptions($event)"
                    ></rt-trip-error-more-options>
                    <button mat-icon-button (click)="tripSidenav.toggle()">
                        <fa-icon [icon]="icons.menu"></fa-icon>
                    </button>
                </span>
            </mat-toolbar-row>
        </mat-toolbar>
        <div class="container-fluid jump-nav">
            <mat-chip-listbox>
                <mat-chip-option
                    bdsScrollSpyLink="tripErrorGrid"
                    color="accent"
                    [selectable]="false"
                    [highlighted]="(scrollSpyService.currentSection | async) === 'tripErrorGrid'"
                    (click)="setCurrentSection('tripErrorGrid')"
                >
                    <span>Interface Validations Grid</span>
                </mat-chip-option>
                <mat-chip-option
                    bdsScrollSpyLink="tripErrorDetailsAnchor"
                    color="accent"
                    [selectable]="false"
                    [highlighted]="
                        (scrollSpyService.currentSection | async) === 'tripErrorDetailsAnchor'
                    "
                    (click)="setCurrentSection('tripErrorDetailsAnchor')"
                >
                    <span>Interface Validations Detail</span>
                </mat-chip-option>
                <mat-chip-option
                    *ngIf="tripError.tcmEquipmentOrmId"
                    bdsScrollSpyLink="productAnchor"
                    color="accent"
                    [selectable]="false"
                    [highlighted]="(scrollSpyService.currentSection | async) === 'productAnchor'"
                    (click)="setCurrentSection('productAnchor')"
                >
                    <span>Product</span>
                </mat-chip-option>
                <mat-chip-option
                    *ngIf="tripError.custNo"
                    bdsScrollSpyLink="custAnchor"
                    (click)="custPanel.open(); setCurrentSection('custAnchor')"
                    color="accent"
                    [selectable]="false"
                    [highlighted]="(scrollSpyService.currentSection | async) === 'custAnchor'"
                >
                    <span>Customer</span>
                </mat-chip-option>
                <mat-chip-option
                    *ngIf="tripError.routeCode"
                    bdsScrollSpyLink="routeAnchor"
                    (click)="routePanel.open(); setCurrentSection('routeAnchor')"
                    color="accent"
                    [selectable]="false"
                    [highlighted]="(scrollSpyService.currentSection | async) === 'routeAnchor'"
                >
                    <span>Route</span>
                </mat-chip-option>
                <mat-chip-option
                    bdsScrollSpyLink="clmAnchor"
                    (click)="clmPanel.open(); setCurrentSection('clmAnchor')"
                    color="accent"
                    [selectable]="false"
                    [highlighted]="(scrollSpyService.currentSection | async) === 'clmAnchor'"
                >
                    <span>CLM History</span>
                </mat-chip-option>
            </mat-chip-listbox>
        </div>
    </div>
    <mat-sidenav-container>
        <mat-sidenav mode="side" position="end" class="mat-elevation-z4" #tripSidenav>
            Nothing to see here
        </mat-sidenav>
        <div
            bdsScrollSpySection="tripErrorDetailsAnchor"
            [scrollMargin]="116"
            #tripErrorDetailsAnchor
            class="mt-1"
        >
            <div class="div-wrapper">
                <div class="error-message">{{ errorMessage }}</div>
            </div>
            <rt-trip-error-details
                #tripErrorDetails
                [tripError]="tripError"
                [tripRefFieldDefs]="tripRefFieldDefs$ | async"
                [highlightDirty]="true"
                (equipmentChange)="onEquipmentChange($event)"
                (formValidChange)="onFormValidChange($event)"
                (tripValuesChange)="onTripValuesChange($event)"
                (formDirtyChange)="onFormDirtyChange($event)"
                (navigateClmSection)="setCurrentSection('clmAnchor'); clmPanel.open()"
                (notifyToUpdateTrip)="reProcess()"
                [allowPopout]="allowPopout"
            >
            </rt-trip-error-details>
        </div>
        <div
            *ngIf="tripError.custNo"
            class="mb-3"
            bdsScrollSpySection="custAnchor"
            [scrollMargin]="116"
            #custAnchor
        >
            <mat-expansion-panel #custPanel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <fa-icon [icon]="icons.customer" [fixedWidth]="true"></fa-icon>
                        Customer
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <bds-customer-display
                        [customerNumber]="tripError.customerNo"
                        [editLink]="'/customers'"
                        [allowEdit]="true"
                    >
                    </bds-customer-display>
                </ng-template>
            </mat-expansion-panel>
        </div>

        <div
            *ngIf="tripError.tcmEquipmentOrmId"
            class="container"
            bdsScrollSpySection="productAnchor"
            [scrollMargin]="108"
            #productAnchor
        >
            <div class="row">
                <div class="col-10 d-flex flex-row">
                    <span>Products Shipped</span>
                </div>
                <div class="col-2 text-right">
                    <button mat-flat-button (click)="onAddProductClick()">
                        <fa-duotone-icon
                            [icon]="iconAdd"
                            primaryColor="forestgreen"
                            secondaryColor="#97bdd3"
                        ></fa-duotone-icon>
                        Add Product
                    </button>
                </div>
            </div>

            <ng-container *ngFor="let compart of commoditiesShipped; let idx = index">
                <mat-card class="mb-3">
                    <div class="row">
                        <div class="col-10">
                            <trip-commodity-shipped [commodityShipped]="compart">
                            </trip-commodity-shipped>
                            <!-- <rt-trip-commodity-shipped
                                [commodityShipped]="compart"
                                (commodityShippedChange)="commShipChange($event, idx)"
                                [highlightDirty]="true"
                            >
                            </rt-trip-commodity-shipped> -->
                        </div>
                        <div class="col-2">
                            <button mat-icon-button (click)="onEditProductClick(compart)">
                                <fa-duotone-icon
                                    [icon]="iconEdit"
                                    primaryColor="#005c92"
                                    secondaryColor="#005c92"
                                    [fixedWidth]="true"
                                ></fa-duotone-icon>
                            </button>
                            <button mat-icon-button (click)="onDeleteProductClick(compart.ormId)">
                                <fa-duotone-icon
                                    [icon]="iconDelete"
                                    primaryColor="red"
                                    secondaryColor="red"
                                    [fixedWidth]="true"
                                ></fa-duotone-icon>
                            </button>
                        </div>
                    </div>
                </mat-card>
            </ng-container>
        </div>
        <div class="container-fluid">
            <div
                *ngIf="tripError.routeCode"
                class="mb-3"
                bdsScrollSpySection="routeAnchor"
                [scrollMargin]="116"
                #routeAnchor
            >
                <mat-expansion-panel #routePanel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <fa-icon [icon]="icons.route" [fixedWidth]="true"></fa-icon>
                            Route
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                        <bds-route
                            [routeCode]="tripError.routeCode"
                            [readOnly]="routeReadOnly"
                        ></bds-route>
                    </ng-template>
                </mat-expansion-panel>
            </div>
            <div class="mb-3" bdsScrollSpySection="clmAnchor" [scrollMargin]="116" #clmAnchor>
                <mat-expansion-panel #clmPanel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <fa-icon [icon]="icons.history" [fixedWidth]="true"></fa-icon>
                            Current CLM:
                            <ng-container *ngIf="currentClm">
                                {{
                                    currentClm.sightCode
                                        | lookup : (sightCodes | async) : 'id' : 'name'
                                }}
                                <small class="text-muted"
                                    >&nbsp;({{ currentClm.sightCode }})&nbsp;</small
                                >
                                - {{ currentClm.locationCity }}, {{ currentClm.locationState }} -
                                {{
                                    currentClm.clmDateTime | date : 'MM/dd/yyyy HH:mm:ss' : 'UTC'
                                }}</ng-container
                            >
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                        <rt-clm
                            [carId]="tripError.carInit + ' ' + tripError.carNo"
                            [customerNumber]="tripError.customerNo"
                            [destinationCity]="tripError.destinationCity"
                            [destinationState]="tripError.destinationState"
                            [disabledFields]="disabledClmFields"
                            [originCity]="tripError.returnCity"
                            [originState]="tripError.returnState"
                            [tripId]="tripError.ormId"
                            [shipmentDate]="tripError.shipDatetime"
                            [loadEmpty]="tripError.loadEmpty"
                            (onClmReapplied)="reloadClms()"
                        ></rt-clm>
                    </ng-template>
                </mat-expansion-panel>
            </div>
        </div>
    </mat-sidenav-container>
</div>
